import React, { Component } from 'react';
import styled from 'styled-components';
import moment, { Moment as TMoment } from 'moment-timezone';
import { connect } from 'react-redux';
import { themes, Day, TimeSlot, utils, ReduxState, PatientState, MomentTimeZone } from 'kb-shared';
const { mappedTimeZone } = utils;

interface SelectedProps {
  selected?: boolean;
}

type organizedListType = {
  Morning: Array<TimeSlot>;
  Afternoon: Array<TimeSlot>;
  Evening: Array<TimeSlot>;
};

const BookingTimeContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
`;
const TimeOfDayText = styled.div`
  ${themes.fonts.FoundersGrotesk};
  font-size: 18px;
  color: ${themes.colors.KBNight};
  padding-bottom: 10px;
  font-weight: bolder;
`;

const DayContainer = styled.div`
  padding-bottom: 20px;
`;

const TimeSlotContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const TimeSlotBubble = styled.div`
  cursor: pointer;
  width: 80px;
  height: 28px;
  border-radius: 14px;
  border: solid 1px ${themes.colors.KBNight};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
  margin-right: 4px;
  margin-bottom: 4px;
  :hover {
    border: solid 2px ${themes.colors.KBNight};
  }
  ${({ selected }: SelectedProps) => `
    background-color: ${selected ? themes.colors.KBNight : 'white'};
  `}
  transition: all 400ms ease 0s;
`;

const TimeSlotText = styled.div`
  ${themes.fonts.FoundersGrotesk};
  font-size: 14px;
  ${({ selected }: SelectedProps) => `
    color: ${selected ? 'white' : themes.colors.KBNight};
  `}
  transition: all 400ms ease 0s;
`;

const BookingTimeSelectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const TimeZoneText = styled.div`
  ${themes.fonts.FoundersGrotesk};
  font-size: 14px;
  display: flex;
  margin-top: 4px;
  padding: 0 0 20px 20px;
`;

const TimeSlotMessage = styled.div`
  ${themes.fonts.FoundersGrotesk};
  font-size: 14px;
  margin-top: 4px;
  padding: 0 0 10px 10px;
  color: ${themes.colors.KBNight};
`;

interface Props {
  timeslots: Array<TimeSlot>;
  date?: TMoment;
  selectedTimeSlot?: TimeSlot | null;
  onSelectTimeSlot: (slot: TimeSlot) => void;
  patient?: PatientState;
}

class BookingTimeSelection extends Component<Props, any> {
  defaultTimeZone = 'UTC';

  getTimeZone(): string {
    const { patient } = this.props;

    if (patient && patient.isLoggedIn) {
      return patient.patient.preferredTimezone || patient.patient.lab?.timeZone || 'UTC';
    }

    return this.defaultTimeZone;
  }

  getMomentTimeZone(timeZone: string): string {
    const { patient } = this.props;
    if (patient && patient.isLoggedIn) {
      return mappedTimeZone(timeZone as MomentTimeZone);
    }

    return moment.tz(moment.tz.guess()).format('zz');
  }

  render() {
    const date = this.props;
    const timeZone = this.getTimeZone();
    const momentTimeZone = this.getMomentTimeZone(timeZone);

    return (
      <BookingTimeSelectionContainer>
        <DaySection
          // @ts-ignore
          day={date}
          selectedTimeSlotId={this.props.selectedTimeSlot ? this.props.selectedTimeSlot.id : null}
          onSelect={this.props.onSelectTimeSlot}
          showInTimezone={momentTimeZone}
        />
        {date.timeslots.length > 0 && <TimeZoneText>All times are {timeZone}</TimeZoneText>}
      </BookingTimeSelectionContainer>
    );
  }
}

const DaySection = (props: {
  day?: Day;
  selectedTimeSlotId: string | null;
  onSelect: (slot: TimeSlot) => void;
  showInTimezone: string;
}) => {
  const organizedList = {
    Morning: Array<TimeSlot>(),
    Afternoon: Array<TimeSlot>(),
    Evening: Array<TimeSlot>()
  };
  if (props.day && props.day.timeslots) {
    props.day.timeslots.forEach((slot: TimeSlot) => {
      const timeParsed = moment(slot.startTime)
        // @ts-ignore
        .tz(props.showInTimezone);
      const hour = timeParsed.hours();

      if (hour < 12) {
        organizedList['Morning'].push(slot);
      } else if (hour < 17) {
        organizedList['Afternoon'].push(slot);
      } else {
        organizedList['Evening'].push(slot);
      }
    });
  }

  return (
    <BookingTimeContainer>
      {Object.keys(organizedList).map((key: string) => (
        <DayContainer key={key}>
          <TimeOfDayText>{key}</TimeOfDayText>
          <TimeSlotContainer>
            {organizedList[key as keyof organizedListType].length == 0 ? (
              <TimeSlotMessage>There are no available time slots</TimeSlotMessage>
            ) : (
              organizedList[key as keyof organizedListType].map((slot: TimeSlot) => {
                const selected = slot.id === props.selectedTimeSlotId;
                return (
                  <TimeSlotBubble
                    key={slot.id}
                    selected={selected}
                    onClick={() => {
                      props.onSelect(slot);
                    }}
                  >
                    <TimeSlotText selected={selected}>
                      {moment(slot.startTime)
                        // @ts-ignore
                        .tz(props.showInTimezone)
                        .format('h:mm A')}
                    </TimeSlotText>
                  </TimeSlotBubble>
                );
              })
            )}
          </TimeSlotContainer>
        </DayContainer>
      ))}
    </BookingTimeContainer>
  );
};

const mapStateToProps = (state: ReduxState) => ({
  patient: state.patient
});

export default connect(mapStateToProps)(BookingTimeSelection);
